import { useContext } from "react";
import { FaTools } from "react-icons/fa";
import { ClashAltBookingContext } from "../../context/ClashAltBooking";
import { InfoDndContext } from "../../context/InfoDndContext";
import { useNavigate } from "react-router-dom";

import { getHourMinute } from "../../utils/fechas";

interface ICard {
  item: any;
  rowPropuesto?: any;
  fastAdd?: any;
  row: any;
  col: any;
  dirtyData: any[];
  backGColor: string;
  reservationInfo?: {
    name: string;
    resource: string;
    location: string;
    driver: string;
    startTime: string;
    endTime: string;
  };
}

export default function Card({
  row,
  col,
  reservationInfo,
  item,
  rowPropuesto,
  fastAdd,
  dirtyData,
  backGColor,
  ...rest
}: ICard) {
  let bgColor = "#cccccc";
  const { infoDnd } = useContext(InfoDndContext);

  const navigate = useNavigate();
  const dirtyCard = dirtyData?.find(
    (data) => data?.modified === true && item.id === data.id
  );

  // console.log({ dirtyCard });

  if (
    rowPropuesto &&
    rowPropuesto.valid &&
    rowPropuesto.item.id === item.id
  )
    bgColor = "#FFC107";
  else if (item.type === "used") bgColor = item.color;

  if (
    rowPropuesto &&
    rowPropuesto.valid &&
    item.type !== "used" &&
    rowPropuesto.rowIndex === row &&
    rowPropuesto.colIndex === col
  )
    bgColor = "#FFC107";

  if (item.bookingType === "CLEANING") bgColor = "#616161";

  bgColor = "#ff0000";

  const { bookingClash } = useContext(ClashAltBookingContext);

  const isDragging = !true;

  return item.type === "used" ? (
    // @ts-ignore
    <div
      className={`select-none rounded-md w-full ${
        isDragging ? "opacity-60" : "opacity-100"
      }`}
      {...rest}
    >
      <div className="flex items-center mb-[2px] justify-start">
        {/* <div className="mr-[5px] -mt-[2px]">
          {(Array.isArray(infoDnd?.collisionsIds) &&
            infoDnd.collisionsIds.includes(item.id)) ||
          (Array.isArray(bookingClash) &&
            bookingClash.includes(item.id)) ? (
            <span>⚠️</span>
          ) : (
            <img
              src="/icons/clock-icon.svg"
              alt=""
              className="w-3 h-3"
            />
          )}
        </div> */}

        <div className="mr-[5px] -mt-[2px]">
          {item.colision ? (
            <span>⚠️</span>
          ) : (
            <img
              src="/icons/clock-icon.svg"
              alt=""
              className="w-3 h-3"
            />
          )}
        </div>

        <div>
          <p className="text-white text-[10px]">
            {getHourMinute(item.from)}
          </p>
        </div>
      </div>

      <>
        <p className="flex whitespace-nowrap overflow-hidden text-ellipsis text-[18px] items-center mb-[3px] text-white font-semibold">
          {item.cliente?.length > 12
            ? `${item.cliente?.slice(0, 12)}..`
            : item?.cliente}
        </p>

        <div className="flex items-end gap-x-1 absolute bottom-[7px] right-[7px]">
          {/* <p className="text-[10px] text-white">
            {item.id}
          </p> */}
          {dirtyCard && (
            <div className="border border-white p-1 rounded-md">
              <svg
                width="15"
                height="15"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.25 9.70983L10.57 6.99983L12.83 4.73983C13.0626 4.50845 13.2471 4.23342 13.373 3.93052C13.4989 3.62763 13.5637 3.30284 13.5637 2.97483C13.5637 2.64681 13.4989 2.32202 13.373 2.01913C13.2471 1.71623 13.0626 1.4412 12.83 1.20983C12.3614 0.742675 11.7267 0.480355 11.065 0.480355C10.4034 0.480355 9.76866 0.742675 9.30005 1.20983L8.41005 2.08983L7.00005 3.49983L4.28005 0.749825C4.0447 0.520159 3.72889 0.391602 3.40005 0.391602C3.07121 0.391602 2.7554 0.520159 2.52005 0.749825L0.750047 2.51983C0.633639 2.63594 0.541282 2.77388 0.478266 2.92574C0.41525 3.0776 0.382812 3.24041 0.382812 3.40483C0.382812 3.56924 0.41525 3.73205 0.478266 3.88391C0.541282 4.03577 0.633639 4.17371 0.750047 4.28983L3.50005 6.99983L3.28005 7.21983L2.39005 8.09983L0.640047 11.7598C0.526787 11.9935 0.489134 12.2567 0.532322 12.5128C0.575509 12.7689 0.697391 13.0052 0.881034 13.1888C1.06468 13.3725 1.30096 13.4944 1.55705 13.5376C1.81315 13.5807 2.07633 13.5431 2.31005 13.4298L5.93005 11.6798L6.42005 11.1898L6.81005 10.7998L7.00005 10.5698L9.68005 13.2498C9.9154 13.4795 10.2312 13.608 10.56 13.608C10.8889 13.608 11.2047 13.4795 11.44 13.2498L13.21 11.4798C13.3291 11.3664 13.4246 11.2305 13.4911 11.0801C13.5576 10.9296 13.5937 10.7676 13.5974 10.6031C13.6011 10.4387 13.5724 10.2752 13.5128 10.1219C13.4531 9.96857 13.3639 9.82855 13.25 9.70983ZM11.06 1.70983C11.3924 1.70875 11.7119 1.838 11.95 2.06983C12.0665 2.18594 12.1588 2.32388 12.2218 2.47574C12.2848 2.6276 12.3173 2.79041 12.3173 2.95483C12.3173 3.11924 12.2848 3.28205 12.2218 3.43391C12.1588 3.58577 12.0665 3.72371 11.95 3.83983L10.18 2.11983C10.4157 1.89041 10.7312 1.76135 11.06 1.75983V1.70983ZM1.63005 3.39983L3.40005 1.63983L4.22005 2.45983L3.35005 3.33983L4.23005 4.21983L5.11005 3.33983L6.11005 4.33983L4.38005 6.14983L1.63005 3.39983ZM1.76005 12.3098L3.33005 9.07983L5.00005 10.7398L1.76005 12.3098ZM5.93005 9.90983L4.16005 8.13983L9.30005 2.99983L11.06 4.75983L5.93005 9.90983ZM10.6 12.3598L7.92005 9.68983L9.69005 7.91983L10.62 8.84983L9.74005 9.72983L10.62 10.6198L11.51 9.72983L12.37 10.5998L10.6 12.3598Z"
                  fill="white"
                />
              </svg>
            </div>
          )}
        </div>

        {item.bookingType !== "CLEANING" && (
          <div className="flex items-center mb-[3px]">
            <div className="mr-[5px]">
              <img src="/icons/boat-icon.svg" alt="" />
            </div>
            <p className="text-white text-xs">
              {item.boatName || "No boat"}
            </p>
          </div>
        )}

        <div className="flex items-center">
          <div className="mr-[5px]">
            <img src="/icons/location-icon.svg" alt="" />
          </div>

          <p className="text-white text-xs">
            {item.pickup || (
              <span className="flex items-center gap-x-[3px]">
                No pickup{" "}
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.44653 9.63594L5.6434 0.885938C5.65434 0.645313 5.44653 0.4375 5.2059 0.4375H3.92622C3.67465 0.4375 3.47778 0.645313 3.48872 0.885938L3.68559 9.63594C3.69653 9.87656 3.88247 10.0625 4.12309 10.0625H4.99809C5.23872 10.0625 5.43559 9.87656 5.44653 9.63594Z"
                    fill="#F44336"
                  />
                  <path
                    opacity="0.2"
                    d="M4.81172 5.4694C4.84453 5.26159 4.75703 2.60378 4.75703 2.60378C4.75703 2.60378 4.76797 2.22096 4.45078 2.18815C4.14453 2.15534 4.03516 2.43971 4.03516 2.63659C4.03516 2.83346 4.07891 4.98815 4.10078 5.18503C4.11172 5.3819 4.30859 5.58971 4.49453 5.6444C4.68047 5.69909 4.78984 5.62253 4.81172 5.4694Z"
                    fill="white"
                  />
                  <path
                    opacity="0.2"
                    d="M4.33066 1.82734C4.53 1.82734 4.6916 1.66575 4.6916 1.46641C4.6916 1.26707 4.53 1.10547 4.33066 1.10547C4.13132 1.10547 3.96973 1.26707 3.96973 1.46641C3.96973 1.66575 4.13132 1.82734 4.33066 1.82734Z"
                    fill="white"
                  />
                  <path
                    d="M4.82324 13.5625C5.54812 13.5625 6.13574 12.9749 6.13574 12.25C6.13574 11.5251 5.54812 10.9375 4.82324 10.9375C4.09837 10.9375 3.51074 11.5251 3.51074 12.25C3.51074 12.9749 4.09837 13.5625 4.82324 13.5625Z"
                    fill="#CC3333"
                  />
                  <path
                    d="M4.63731 13.3762C5.25949 13.3762 5.76387 12.8718 5.76387 12.2496C5.76387 11.6274 5.25949 11.123 4.63731 11.123C4.01512 11.123 3.51074 11.6274 3.51074 12.2496C3.51074 12.8718 4.01512 13.3762 4.63731 13.3762Z"
                    fill="#F44336"
                  />
                  <path
                    opacity="0.2"
                    d="M3.99206 11.8572C4.12331 11.6603 4.40768 11.4962 4.703 11.4525C4.77956 11.4416 4.84518 11.4416 4.91081 11.4634C4.95456 11.4853 4.99831 11.5291 4.9655 11.5728C4.94362 11.6166 4.88893 11.6275 4.84518 11.6384C4.57175 11.715 4.32018 11.9009 4.16706 12.1197C4.11237 12.2072 4.01393 12.4369 3.90456 12.3822C3.79518 12.3056 3.828 12.0978 3.99206 11.8572Z"
                    fill="white"
                  />
                  <path
                    d="M5.67598 0.4375H5.20566C5.45723 0.4375 5.6541 0.645313 5.64316 0.885938L5.44629 9.63594C5.43535 9.87656 5.24941 10.0625 5.00879 10.0625H5.4791C5.71973 10.0625 5.9166 9.87656 5.9166 9.63594L6.11348 0.885938C6.12441 0.645313 5.9166 0.4375 5.67598 0.4375Z"
                    fill="#CC3333"
                  />
                  <path
                    d="M9.82153 9.63594L10.0184 0.885938C10.0293 0.645313 9.82153 0.4375 9.5809 0.4375H8.30122C8.04965 0.4375 7.85278 0.645313 7.86372 0.885938L8.06059 9.63594C8.07153 9.87656 8.25747 10.0625 8.49809 10.0625H9.37309C9.61372 10.0625 9.81059 9.87656 9.82153 9.63594Z"
                    fill="#F44336"
                  />
                  <path
                    opacity="0.2"
                    d="M9.18672 5.4694C9.21953 5.26159 9.13203 2.60378 9.13203 2.60378C9.13203 2.60378 9.14297 2.22096 8.82578 2.18815C8.51953 2.15534 8.41016 2.43971 8.41016 2.63659C8.41016 2.83346 8.45391 4.98815 8.47578 5.18503C8.48672 5.3819 8.68359 5.58971 8.86953 5.6444C9.05547 5.69909 9.16484 5.62253 9.18672 5.4694Z"
                    fill="white"
                  />
                  <path
                    opacity="0.2"
                    d="M8.70566 1.82734C8.905 1.82734 9.0666 1.66575 9.0666 1.46641C9.0666 1.26707 8.905 1.10547 8.70566 1.10547C8.50632 1.10547 8.34473 1.26707 8.34473 1.46641C8.34473 1.66575 8.50632 1.82734 8.70566 1.82734Z"
                    fill="white"
                  />
                  <path
                    d="M9.19824 13.5625C9.92312 13.5625 10.5107 12.9749 10.5107 12.25C10.5107 11.5251 9.92312 10.9375 9.19824 10.9375C8.47337 10.9375 7.88574 11.5251 7.88574 12.25C7.88574 12.9749 8.47337 13.5625 9.19824 13.5625Z"
                    fill="#CC3333"
                  />
                  <path
                    d="M9.0123 13.3762C9.63449 13.3762 10.1389 12.8718 10.1389 12.2496C10.1389 11.6274 9.63449 11.123 9.0123 11.123C8.39012 11.123 7.88574 11.6274 7.88574 12.2496C7.88574 12.8718 8.39012 13.3762 9.0123 13.3762Z"
                    fill="#F44336"
                  />
                  <path
                    opacity="0.2"
                    d="M8.36706 11.8572C8.49831 11.6603 8.78268 11.4962 9.078 11.4525C9.15456 11.4416 9.22018 11.4416 9.28581 11.4634C9.32956 11.4853 9.37331 11.5291 9.3405 11.5728C9.31862 11.6166 9.26393 11.6275 9.22018 11.6384C8.94675 11.715 8.69518 11.9009 8.54206 12.1197C8.48737 12.2072 8.38893 12.4369 8.27956 12.3822C8.17018 12.3056 8.203 12.0978 8.36706 11.8572Z"
                    fill="white"
                  />
                  <path
                    d="M10.051 0.4375H9.58066C9.83223 0.4375 10.0291 0.645313 10.0182 0.885938L9.82129 9.63594C9.81035 9.87656 9.62441 10.0625 9.38379 10.0625H9.8541C10.0947 10.0625 10.2916 9.87656 10.2916 9.63594L10.4885 0.885938C10.4994 0.645313 10.2916 0.4375 10.051 0.4375Z"
                    fill="#CC3333"
                  />
                </svg>
              </span>
            )}
          </p>
        </div>
      </>
    </div>
  ) : (
    // @ts-ignore
    <div
      className={`p-[10px] w-full h-[60px] ${
        isDragging ? "opacity-60" : "opacity-100"
      } select-none rounded-md`}
      style={{ backgroundColor: backGColor }}
      onClick={() => {
        if (item?.nextUsed > 0) fastAdd(item);
        //  else navigate(`/create-booking/${item.id}`)
      }}
      {...rest}
    >
      <div className="flex items-center">
        <div className="mr-[5px] -mt-[2px]">
          <div>
            <img
              src="/icons/clock-icon.svg"
              alt="SVG"
              className="w-3 h-3"
            />
          </div>
        </div>

        {rowPropuesto &&
        rowPropuesto.valid &&
        rowPropuesto.item.id === item.id ? (
          <p className="text-white text-xs">
            {getHourMinute(rowPropuesto.newFrom)} →{" "}
            {getHourMinute(
              rowPropuesto.newFrom + rowPropuesto.item.duration
            )}
          </p>
        ) : (
          <div>
            <p className="text-white text-[10px]">
              {getHourMinute(item.from)}
            </p>
            {/* <p>{item?.nextUsed}</p> */}
          </div>
        )}
      </div>
    </div>
  );
}
